export default "__VITE_ASSET__D6TISwZY__"